<template>
  <div class="menuContainer">
    <p class="title">百宝箱</p>
    <el-menu
      :default-active="activeProduct"
      class="el-menu-demo"
      mode="vertical"
      router
      text-color="#333"
    >
      <el-submenu index="/treasureTrove/incomeCalculator">
        <template slot="title">理财计算器 </template>
        <el-menu-item index="/treasureTrove/incomeCalculator"
          >收益计算器</el-menu-item
        >
        <el-menu-item index="/treasureTrove/loanCalculator"
          >贷款计算器</el-menu-item
        >
      </el-submenu>
    </el-menu>
  </div>
</template>

<script>
export default {
  computed: {
    activeProduct() {
      return this.$route.path
    },
  },
}
</script>

<style lang="scss" scoped></style>
